import { Button as FoodsButton, Typography as FoodsTypography } from "@foodpilot/foods";
import { Button as MuiButton, Stack, Typography as MuiTypography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFoodpilotContext, VIEW, SETTINGS, MODIFY, SCORE_TYPE } from "../../context/FoodpilotContext";
import { URLHandler } from "src/services/URLHandler";
import type { ComponentAppearance } from "src/components/appearance";

type NoScoresAvailableMessageProps = { appearance?: ComponentAppearance };

export const NoScoresAvailableMessage = ({ appearance = "legacy" }: NoScoresAvailableMessageProps) => {
    const { canUser } = useFoodpilotContext();
    const { t } = useTranslation();
    const theme = useTheme();
    const isProductUxV2 = appearance === "product-v2";

    const canConfigureScores = canUser(VIEW, SETTINGS) && canUser(MODIFY, SCORE_TYPE);
    const Typography = isProductUxV2 ? FoodsTypography : MuiTypography;
    const Button = isProductUxV2 ? FoodsButton : MuiButton;

    return (
        <Stack alignItems="center" padding={theme.spacing(2)}>
            <Stack maxWidth={"50%"}>
                <Typography variant="body-medium">
                    {t("scores.no_scores_defined", "You don't have any scores defined for this Category of Entity")}
                </Typography>
                {canConfigureScores ?
                    <Button variant="primary" href={URLHandler.settings.scores()} target="_blank">
                        {t("scores.go_to_score", "Setup your score")}
                    </Button>
                :   <Typography variant="body-medium">
                        {t("scores.ask_admin_to_configure", "Ask an administrator to configure the scores")}
                    </Typography>
                }
            </Stack>
        </Stack>
    );
};
